var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38281 1.01172L3.99219 1.38281C3.89453 1.48047 3.89453 1.63672 3.99219 1.71484L7.01953 4.74219H0.359375C0.222656 4.74219 0.125 4.85938 0.125 4.97656V5.52344C0.125 5.66016 0.222656 5.75781 0.359375 5.75781H7.01953L3.99219 8.80469C3.89453 8.88281 3.89453 9.03906 3.99219 9.13672L4.38281 9.50781C4.46094 9.60547 4.61719 9.60547 4.71484 9.50781L8.79688 5.42578C8.89453 5.32812 8.89453 5.19141 8.79688 5.09375L4.71484 1.01172C4.61719 0.914062 4.46094 0.914062 4.38281 1.01172Z",
    fill: "#6c757d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightMuted);
export default __webpack_public_path__ + "static/media/arrow-right-muted.ce68f30d.svg";
export { ForwardRef as ReactComponent };